import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReadContext } from "../../common/context/ReadContext";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import VoiceOverOffIcon from "@mui/icons-material/VoiceOverOff";
import { Tooltip } from '@mui/material';
import { stopSpeech } from "./AiShoppingChatInfo";
import { setLastMessage } from "../../store/slices/shoppingAssistanceSlice";
const FloatingOptions = () => {
  const {isConversionAutoEnabled} = useSelector((state) => state.aiShoppingInfo);
  const { isReadEnabled, setIsReadEnabled, cancel } = useReadContext();
  const selector = useSelector((state) => state);
  const aiShoppingInfoList = selector.aiShoppingInfo;
  const dispatch = useDispatch()
  const toggleVoice = async () => {
    if (isReadEnabled) {
      await stopSpeech(dispatch);
      dispatch(setLastMessage({}))
      cancel(); // Stop any ongoing speech synthesis when disabling voice
    }
    setIsReadEnabled((prev) => !prev); // Toggle the voice state
  };


  
  return (
    // <div >
      <button
      className="voice-enable-button-m"
        style={{
          ... isReadEnabled ? floatingButtonStyles.button : floatingButtonStyles.buttonDisable,
          cursor: aiShoppingInfoList.loading ? "not-allowed" : "pointer",
        }}
        type="button"
        onClick={(e) => toggleVoice(e)}
        disabled={aiShoppingInfoList.loading}
        aria-label={isReadEnabled ? "Disable Voice" : "Enable Voice"}
      >
        {isReadEnabled ? (
          <Tooltip
          title={"Disable Voice Mode"}
          enterTouchDelay={0}
          leaveTouchDelay={5000}
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "rgba(97, 97, 97, 0.92) !important",
                color: "white",
                fontSize: "14px",
              },
            },
          }}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0], // Centered directly above the button
                  },
                },
              ],
            },
          }}
        >
          <RecordVoiceOverIcon style={floatingButtonStyles.icon} />
        </Tooltip>
      ) : (
        <Tooltip
          title={"Enable Voice Mode"}
          enterTouchDelay={0}
          leaveTouchDelay={5000}
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "rgba(97, 97, 97, 0.92) !important",
                color: "white",
                fontSize: "14px",
              },
            },
          }}
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, 0], // Centered directly above the button
                  },
                },
              ],
            },
          }}
        >
          <VoiceOverOffIcon style={floatingButtonStyles.icon} />
        </Tooltip>
        )}
      </button>
    // </div>
  );
};

const floatingButtonStyles = {
  container: {
    position: "absolute",
    top: "0px",
    right:"-50px",
    // right: "2px",
    // transform: "translateY(-50%)",
    zIndex: 1000,
    '@media (max-width:768px)': {
      right: "-40px",
      top: "-5px",
    },
  },
  button: {
    position: "absolute",
    top: "0px",
    right:"-50px",
    zIndex: 1000,
    backgroundColor: "#DB487E",
    border: "none",
    borderRadius: "6px",
    width: "45px",
    height: "45px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  buttonDisable: {
   position: "absolute",
    top: "0px",
    right:"-50px",
    backgroundColor: "#25C9D0",
    border: "none",
    borderRadius: "6px",
    width: "45px",
    height: "45px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    color: "#fff",
    fontSize: "20px",
  },
};

export default FloatingOptions;
